















// Import vendors ----------------------------------------------------------------------------------
import { defineComponent, ref } from '@vue/composition-api';
// Import components -------------------------------------------------------------------------------
import ChartContainer from '@/components/charts/ChartContainer.vue';
import ChartRehabGroupGeneralParameters from '@/components/charts/rehab/groups/ChartRehabGroupGeneralParameters.vue';
import ElementResultsSwitch from '@/components/elements/ElementResultsSwitch.vue';
// Import utils ------------------------------------------------------------------------------------
import { useVuetifyBreakpoints } from '@/utils/vuetify-breakpoints.utils';
import { useCDN } from '@/utils/cdn.utils';
import { useRehab } from '@/utils/rehab.utils';
// -------------------------------------------------------------------------------------------------

export default defineComponent({
  name: 'ChartRehabContainerSingleHopGeneralParameters',
  components: {
    ChartContainer,
    ChartRehabGroupGeneralParameters,
    ElementResultsSwitch
  },
  props: {
    aggregates: {
      type: Object,
      required: true
    },
    norms: {
      type: Object,
      required: false
    },
    displayMetrics: {
      type: Object,
      required: true
    }
  },
  setup(properties) {
    const { isLgAndLarger } = useVuetifyBreakpoints();
    const { cdn } = useCDN();
    const { getSingleHopGeneralParametersSimplifiedData, getSingleHopGeneralParametersAdvancedData } =
      useRehab();

    const isAdvancedMode = ref(false);

    const simplifiedModeCharts = getSingleHopGeneralParametersSimplifiedData(properties.aggregates);

    const advancedModeCharts = getSingleHopGeneralParametersAdvancedData(properties.aggregates);

    return {
      // Values
      isAdvancedMode,
      isLgAndLarger,
      simplifiedModeCharts,
      advancedModeCharts,
      // Methods
      cdn
    };
  }
});
